import { DateTime } from "luxon";
import { IanaTimezone } from "./iana-timezone";

/**
 * `timezone`'s offset at `at`, as `"UTC+8"` / `"UTC+9:30"` / `"UTC"`.
 *
 * Built from the offset rather than `Intl`'s short zone name, which varies by runtime and locale —
 * it gives `"GMT+10"` for Sydney, not `"AEST"`.
 *
 * `undefined` for a zone that is not an IANA zone, such as one from a hand-edited link, rather than
 * throwing, since a label is shown even where the zone is about to be reported as invalid.
 */
export function offsetLabel(timezone: string, at: Date): string | undefined {
  if (!IanaTimezone.safeParse(timezone).success) return undefined;
  const minutes = DateTime.fromJSDate(at, { zone: timezone }).offset;
  if (minutes === 0) return "UTC";
  const sign = minutes > 0 ? "+" : "-";
  const hours = Math.floor(Math.abs(minutes) / 60);
  const rest = Math.abs(minutes) % 60;
  return `UTC${sign}${String(hours)}${rest === 0 ? "" : `:${String(rest).padStart(2, "0")}`}`;
}
